import { axisBottom, axisLeft, axisRight, scaleLinear } from 'd3'
import { select } from 'd3'

export const MARGIN = { top: 20, right: 30, bottom: 0, left: 60 }

export function addGridLines(width, height, svg) {
  const y = scaleLinear().range([height, 0])
  const yAxisGrid = axisRight(y).tickSize(width).tickFormat('').ticks(7)
  const axisG = svg.append('g').call(yAxisGrid)
  axisG
    .selectAll('line')
    .attr('stroke', '#E7ECF3')
    .attr('stroke', (_d, i) => (i === 0 ? 'none' : '#E7ECF3'))
  axisG.selectAll('path').attr('stroke', 'none')
}

export function setupAxes(
  svg,
  { width, height, selectedValue, subtextLegendAxisY, textLegendAxisY }
) {
  const x = scaleLinear().range([0, width]).domain([0, 1500])
  const y = scaleLinear().range([height, 0]).domain([0, 1500])

  const step = Math.ceil(selectedValue / 100)

  const axisX = svg
    .append('g')
    .attr('transform', `translate(0, ${height})`)
    .call(
      axisBottom(x)
        .ticks(7)
        .tickFormat(() => '')
    )
  axisX.selectAll('line').attr('stroke', 'none')
  axisX.selectAll('path').attr('stroke', '#C0CBD8').attr('stroke-width', 2)

  const axisY = svg.append('g').call(
    axisLeft(y)
      .ticks(7)
      .tickFormat((_d, i) => {
        if (i === 4) return `$ ${i * step + step}+`
        if (i === 5) return subtextLegendAxisY
        if (i === 6) return textLegendAxisY
        if (i === 0) return 0
        return `$ ${i * step + step}`
      })
      .tickValues([0, 300, 600, 900, 1200, 1400, 1500])
  )

  axisY.selectAll('line').attr('stroke', 'none')
  axisY.selectAll('path').attr('stroke', '#C0CBD8').attr('stroke-width', 2)
  axisY
    .selectAll('text')
    .attr('color', '#616A7C')
    .attr('font-weight', '400')
    .attr('font-size', '12px')
    .attr('font-family', 'Ultramarine')

  axisY.selectAll('path').attr('d', function () {
    const d = select(this).attr('d')
    return d.replace('.5H-6', '').replace('M-6', 'M-0').replace('H-6', 'H-0')
  })

  axisX.selectAll('path').attr('d', function () {
    const d = select(this).attr('d')
    return d.replace('.5V6', '').replace(',6V0', ',0V0').replace('V6', 'V0')
  })
}

const STRIPE_PATTERNS = [
  { id: 'achieveStripes', className: 'barLine1', colors: ['#3B6AF7', '#2C47F6'] },
  { id: 'currentStripes', className: 'barLine2', colors: ['#C0CBD8', '#E7ECF3'] },
  { id: 'waitStripes', className: 'barLine3', colors: ['#CF264E', '#E55F80'] },
]

export function addStripedPatterns(svg, highestPoints) {
  STRIPE_PATTERNS.forEach((def, i) => {
    svg
      .append('defs')
      .append('pattern')
      .attr('id', def.id)
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('width', 6)
      .attr('height', 6)
      .attr('patternTransform', 'rotate(45)')
      .attr('class', def.className)
      .attr('x', Math.round(highestPoints?.[i]?.x ?? 0))
      .attr('y', Math.round(highestPoints?.[i]?.y ?? 0))
      .call((pattern) => {
        pattern
          .append('rect')
          .attr('x', 0)
          .attr('y', 0)
          .attr('width', 4)
          .attr('height', 6)
          .attr('fill', def.colors[0])
        pattern
          .append('rect')
          .attr('x', 4)
          .attr('y', 0)
          .attr('width', 2)
          .attr('height', 6)
          .attr('fill', def.colors[1])
      })
  })
}
